var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManHairstyle1A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type4_x5F_hair:"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M456.2,166.4c5.2-1.8,14-1.8,19.2,0.8c-1.7-9.1-12-11.1-19.8-11.9c5.1-7.7,3.3-18.6-1.5-26.6 c-1.4,5.3-4.3,10.1-8.8,13.8c8.1-19.4,3.4-48.4-16.8-59c-0.1,9-7.8,18.8-16,21.4c0,0,0,0,0,0.1c-0.2,0.2-0.2,0.2,0,0 c0,0,0,0,0.1,0c8.7-11.1,1.7-24.6-9.1-32.1c-1.2,11.4-9.2,23.7-19.4,29.5c2.7-9.8,0.5-27.1-10-33.1 c-1.7,13.6-18.4,20.9-29.4,24.8c-15.5,5.5-33.5,4.8-49.1,10.6c-15.9,6-29.4,22.1-27.5,38.3c-3.9-6.1-7.6-11.6-4.6-18.6 c-13.3,8.5-19,28.9-8.9,40.4c-12.7,6.1-11.6,20.1-10,32.2c2.2,16.5,7.4,36.3,17,54.3c0.9,1.8,3.3,7.7,4.3,9.3 c-1.4-14.1,3.1-42,5.7-56.7c2.7-15.6,4.9-30.5,23.5-31.7c9.4-0.6,20.3,3.2,29.2,4.8c8.1,1.4,22.1,3.2,30.8,2.7 c17-1,27-4.5,41-8.8c19.6-5.9,19-7.5,30.8,8.2c10.8,14.4,17.9,42.8,19.4,59.8c0.9,10,1.8,22,6.1,30.1c1.4-28,24.8-47.6,10.9-91.8 C461.7,173,460,169.1,456.2,166.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M412.4,104.9C412.4,104.9,412.4,104.8,412.4,104.9C412.4,104.8,412.4,104.9,412.4,104.9 C412.2,105,412.2,105.1,412.4,104.9z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A94E3C",
    d: "M424.2,163.2c13.3,1,30.8-12.9,33.7-25.6c-0.8-3.2-2.1-6.2-3.7-8.9c-1.4,5.3-4.3,10.1-8.8,13.8 c0-0.1,0.1-0.1,0.1-0.2C440,151.4,432.1,161.3,424.2,163.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A94E3C",
    d: "M424.2,163.2L424.2,163.2L424.2,163.2C423.9,163.2,423.9,163.2,424.2,163.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A94E3C",
    d: "M427.2,118.3c-13.6,13.6-29.8,21.5-48.4,25.4c-21.6,4.5-42.4,0.2-64.1-1.1c-10.1-0.6-19.7,0.8-28.6,5.7 c-5.5,3.1-14.6,9.6-17,16.4c5.7-5,12-7.9,20.8-8.2c18.8-0.6,35.9,5.3,54.5,5.3c20,0,39.6-1.1,56.7-12 c13.2-8.5,28.8-24.2,31.9-39.7C432,113.2,429.6,116,427.2,118.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A94E3C",
    d: "M361.5,105.7c9.2-8.8,16.3-21.8,15.4-34.3c-0.9-0.8-1.9-1.6-3-2.2c-0.1,1.1-0.4,2.1-0.7,3 c-0.2,1.8-0.5,3.4-1.2,5.3c-2.9,7.9-8.7,15.2-15.8,20.2c-9.2,6.4-22.2,8.2-33.2,9.6c-11.3,1.4-23.3,4.3-34.4,7.1 c-8.8,2.3-14.1,7.4-18.6,14.1c-1.1,2.7-1.9,5.6-2.2,8.4c11-11.2,30.2-12.8,44.8-15.4C328.1,119,349.5,117.2,361.5,105.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A94E3C",
    d: "M301.6,137.2c2.8-0.6,5.5-1,8.4-1.4c31.6-3.4,73.7-1.3,90.3-32.8c1.2-2.4,2.2-5.1,2.9-7.9 c-1.4,2.3-3,4.5-4.7,6.5c-21.2,23.3-54.7,22.3-84,25.5c-2.9,0.4-5.7,1-8.5,1.6c-16.1,3.5-30.9,10.5-37.7,26.4 C277.2,144.8,288.9,139.9,301.6,137.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManHairstyle1A);
export default __webpack_public_path__ + "static/media/man_hairstyle_1a.5c0321bee0a5c2f7cb49d4964b32673f.svg";
export { ForwardRef as ReactComponent };